import {
  Box,
  getValueByDevice,
  Image,
  Space,
  Stack,
  Text,
  useDevice,
  VStack,
} from 'platform/foundation';

import {isNil} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

import {VehicleImage} from '../../../components/VehicleImage/VehicleImage';
import {CatalogueType} from '../../../hooks/useCatalogue';
import i18n from '../../../i18n/i18n';
import {PriceReportType} from '../../../types/PriceReportType';
import {AvailableCarWithLogo} from '../types/available-car-with-logo';
import {getAdvertisementVehicleBackgroundColor} from '../utils/getAdvertisementVehicleBackgroundColor';
import {VehicleCardContent} from './VehicleCardContent';

interface VehicleCardProps extends TestIdProps {
  priceReport: PriceReportType;
  catalogue: CatalogueType;
  vehicle: AvailableCarWithLogo;
  isMyVehicle: boolean;
}

export function VehicleCard(props: VehicleCardProps) {
  const device = useDevice();

  const isMyAd =
    isNotNil(props.priceReport.vehicle.adId) &&
    props.priceReport.vehicle.adId === props.vehicle.ad_id;

  const backgroundColor = getAdvertisementVehicleBackgroundColor({
    isMyVehicle: props.isMyVehicle,
    isMyAd,
    isPricingNeighbour: props.vehicle.isPricingNeighbour,
  });

  return (
    <Box
      backgroundColor={backgroundColor}
      borderRadius="small"
      border="1px solid"
      borderColor="palettes.neutral.40.100"
    >
      <Stack direction={['column', 'row', 'row', 'row']}>
        {isNil(props.priceReport.vehicle.imageUrl) && isNotNil(props.vehicle.logoUrl) ? (
          <Box width={['100%', 68, 68, 68]} height={[35, 40, 40, 40]} flexShrink={0}>
            <VStack height="100%" justify="center" align="center">
              <Image
                src={props.vehicle.logoUrl}
                width="auto"
                data-testid={suffixTestId('vehicleLogo', props)}
              />
              <Space vertical={3} />
              <Text size="xSmall" color="tertiary" alternative>
                {i18n.t('page.advertisements.yourVehicle')}
              </Text>
            </VStack>
          </Box>
        ) : (
          <VehicleImage
            priceReport={props.priceReport}
            vehicle={props.vehicle}
            isMyVehicle={props.isMyVehicle}
            maxWidth={getValueByDevice(device, '100%', 68, 68, 68)}
            maxHeight={getValueByDevice(device, undefined, 45, 45, 45)}
            ratio={getValueByDevice(device, '3 / 2', undefined, undefined, undefined)}
          />
        )}
        <Box padding={4} flexGrow={1}>
          <VehicleCardContent
            priceReport={props.priceReport}
            catalogue={props.catalogue}
            vehicle={props.vehicle}
            isMyVehicle={props.isMyVehicle}
            isMyAd={isMyAd}
            data-testid={suffixTestId('rowHeader', props)}
          />
        </Box>
      </Stack>
    </Box>
  );
}
